const Badge = () => {
  return (
    <div className="absolute right-2 top-2 z-10">
      <span className="rounded-full bg-red-600 px-2 py-0.5 text-xs font-bold text-white">18+</span>
    </div>
  );
};

export default Badge;
